export default __webpack_public_path__ + "static/media/2b.a72175d1.jpg";